import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import type { APIError } from 'utils/errors';

import { getRequest } from './apiRequests';

const apiUrl = '/api/csrf';

type CSRFTokenResponse = {
  csrf: string;
};

const getCSRFToken = () => getRequest<null, CSRFTokenResponse>(apiUrl);

const useGetCSRFToken = (options: UseQueryOptions<CSRFTokenResponse, APIError> = {}) => {
  return {
    query: useQuery<CSRFTokenResponse, APIError>('csrf', getCSRFToken, {
      ...options,
    }),
  };
};

export const CSRFService = {
  apiUrl,
  useGetCSRFToken,
};
